import React, { useEffect, useRef,  useState } from 'react';
import { IonTextarea, IonButton, IonIcon, IonItem, IonLabel, IonCheckbox, IonModal, IonList, IonToggle, IonInput, IonSpinner } from '@ionic/react';
import { _AIAssistantFunctionURL, _BULK_IMPORT_CARD_LIMIT, _SMALL_SCREEN_WIDTH, _cachedLocalAutoL2image, _defaultButtonColor, _dict, _homeNodePath, _l2audio, _l2color, _l2image, _maxAIInput, _minAIInput, _rootName } from './constants';
import { arrowBack, arrowUpCircle, colorWand, documentTextOutline, image, imageOutline, library } from 'ionicons/icons';
import { useHistory } from 'react-router';
import { useUIStore } from './stateManagement/UIZustand';
import { useImportStore } from './stateManagement/importZustand';
import AddOrReplaceDialog from './dialogs/AddOrReplaceDialog';
import { useGlobalStore } from './stateManagement/globalZustand';
import { auth } from './Auth';
import axios from 'axios';
import { cleanAIAnswer, cleanText, imageToText } from '../foo/text';
import { getRemainingRequests, logMe } from '../foo/user';
import { useUserStore } from './stateManagement/userZustand';
import { goToPayment } from './payments';
import { usePhotoGallery } from './usePhotoGallery';
import { useURLStore } from './stateManagement/URLZustand';


const BulkImport: React.FC = () => {
  const { lang, setShowLoading, isParentMode, setIsParentMode } = useGlobalStore();
  const {
    importMode,
    doImport,
    showOneSentenceAtATime,
    setShowOneSentenceAtATime,
    ignoreNewLines,
    setIgnoreNewLines,
  } = useImportStore();
  const [files, setFiles] = useState<string[]>([]);
  const { isSubscribed, userUniqueId } = useUserStore();
  const [showModal, setShowModal] = useState(false);
  const { setIsAddOrReplaceDialogOpen} = useUIStore();
  const [ activateAI, setActivateAI] = useState(false);
  const [ isLoading, setIsLoading] = useState(false);
  const [ prompt, setPrompt] = useState("");
  const [ isSendButtonEnabled, setIsSendButtonEnabled] = useState(false);
  const [ remainingRequests, setRemainingRequests] = useState<number | null>(null);
  const { takePhoto, photo, setPhoto } = usePhotoGallery();
  const [ text, setText] = useState<string | undefined>(undefined);

  
  const textareaRef = useRef<HTMLIonTextareaElement>(null);
  const { URLVars, getURLTo } = useURLStore();
  const history = useHistory();

  useEffect(() => {
    setPhoto(undefined)
  }, []);

  useEffect(() => {
    const updateRemReq = async () => {
      const newReq = await getRemainingRequests();
      setRemainingRequests(newReq);
    };

    if(activateAI){
      updateRemReq();
    }
  }, [activateAI]);

  useEffect(() => {
    if(isParentMode === false){
      setIsParentMode(true);
    }
  }, [isParentMode]);
 

  useEffect(() => {
    const updateTextFromPic = async () => {
      if(photo !== undefined && photo !== null && photo.length > 100){
        if(textareaRef.current){
          setIsLoading(true);
          let result = await imageToText(photo, lang);
          
          if(result && result.length > 10){
            result = cleanText(result, importMode==="flat");
            textareaRef.current.value = result;
            setText(result);
            
          }
          setIsLoading(false);
        }
      }
    }
    
    updateTextFromPic();
    
  }, [photo]);


  const handleLibraryClick = async () => {
    // Fetch the list of files from the public/data folder
    const response = await fetch('/data/files.json');
    const data = await response.json();
    // Filter the files based on the start and end strings
    const filteredFiles = data.files.filter
      ((file: { [key: string]: string }) =>
        Object.keys(file).some(
          key => (importMode === "tree" ? key.startsWith("sentences") : importMode === "flat" ? key.startsWith("words") : false) && key.endsWith(lang+".txt")
        )
    );
    setFiles(filteredFiles);
    setShowModal(true);
  };


  const handleFileClick = async (file: string) => {
    // Fetch the content of the selected file
    const response = await fetch(`/data/${file}`);
    const content = await response.text();
    if(textareaRef.current){
      textareaRef.current.value = content;
    }
    
    setShowModal(false);
  };
  
  
  const handleSubmit = async (mergeMode:"add" | "replace") => {
    if(textareaRef.current){
      setShowLoading(true);
      const inputText = textareaRef.current.value;
      if(inputText !== undefined && inputText !== null){
        await doImport(inputText, URLVars.nodePath!, mergeMode);
        history.push(getURLTo().talkFromNodePath());
      }
    }
  
  }

  const showOnceSentenceAtATimeCheckboxJSX = importMode === "story" ? <IonItem lines='none'>
      <IonLabel>{_dict.showOnceSentenceAtATime[lang]}</IonLabel>
      <IonCheckbox slot="start" checked={showOneSentenceAtATime}  onIonChange={() => setShowOneSentenceAtATime(!showOneSentenceAtATime)} />
    </IonItem>: null; 

  const ignoreNewLinesCheckBoxJSX = importMode === "story" ? <IonItem lines='none'>
      <IonLabel>{_dict.ignoreNewLines[lang]}</IonLabel>
      <IonCheckbox slot="start" checked={ignoreNewLines}  onIonChange={() => {setIgnoreNewLines(!ignoreNewLines)}} />
    </IonItem>: null;




  const handleAIToggle = () => {
    setActivateAI(!activateAI);
  }

  const handleAIInputChange = (event: any) => {
    setPrompt(event.target.value);
    setIsSendButtonEnabled(event.target.value.length >= _minAIInput);
  }

  const handleButtonClickAuth = async (rewrite:boolean=false) => {
    try {
      setIsLoading(true);
      const authToken = await auth.currentUser?.getIdToken();
      const user = await auth.currentUser;
      // User to JSON string
      const userString = JSON.stringify(user);

      axios.post(_AIAssistantFunctionURL, {
        rewrite: rewrite ? "yes" : "no",
        user: userString,
        message: rewrite ? _dict.prefixForAIAssistantRewrite[lang]+text : _dict.prefixForAIAssistant[lang]+prompt,
      },{
        headers: {
          Authorization: `Bearer ${authToken}`,
          'X-My-Custom-Header': authToken,
          'Content-Type': 'application/json'
        },
      }).then((response:any) => {
        setIsLoading(false);
        if(textareaRef.current){
          textareaRef.current.value =  cleanAIAnswer(response.data, lang);
          setText(textareaRef.current.value);
          getRemainingRequests().then((newReq) => {
            setRemainingRequests(newReq);

          });          
        }
        
        }).catch((error) => {
          setIsLoading(false);
          if(textareaRef.current){
            textareaRef.current.value = cleanAIAnswer(String(error), lang);
            
          }
          
        });
    } catch (error) {
      setIsLoading(false);
      if(textareaRef.current){
        //console.error('Error calling cloud function:', error);
      }
      
    }
  };


  
  return (
    <>
    <div style={{ display: 'flex', alignItems: 'center'}}>
      <IonButton size="large" onClick={() => history.push(getURLTo().talkFromNodePath())} color="light">
        <IonIcon icon={arrowBack} slot="start" />
      </IonButton>
      <div>
        <IonButton size="large"
        onClick={() => {setPhoto(undefined); takePhoto(false)}}
        color="light">
          <IonIcon icon={image} slot="start"  />
         {_dict.textFromImage[lang]}
        </IonButton>
      </div>
      { (importMode === "flat" || importMode === "tree") && <IonButton size="large" onClick={handleLibraryClick} color="light" ><IonIcon icon={library} slot="start" /> {_dict.importSentences[lang]}</IonButton> }      
    </div>
    <div style={{margin:"10px"}}>
      <IonToggle checked={activateAI} onIonChange={handleAIToggle}>{_dict.smartAssistant[lang]}</IonToggle>
      
      { activateAI && remainingRequests !== null &&
      <>
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
        <IonInput disabled={!remainingRequests} onInput={handleAIInputChange} placeholder={_dict.chooseTopic[lang]} maxlength={_maxAIInput} style={{maxWidth:"320px", flex: '1 0 auto'}}></IonInput>
        <IonButton 
          disabled={!isSendButtonEnabled || isLoading || remainingRequests <= 0}
          onClick={() => handleButtonClickAuth(false)}
          style={{"--background": _defaultButtonColor, "--min-height": "auto", padding: "0px 10px", flex: 'none'}}>
          <IonIcon icon={documentTextOutline} slot="start" /> 
          {_dict.create[lang]}
        </IonButton>
        {
        /*<IonButton 
          disabled={text === undefined || text === null || isLoading || remainingRequests === null || remainingRequests <= 0 || text.length < 20 || text.length > 2000}
          onClick={() => handleButtonClickAuth(true)}
          style={{"--background": _defaultButtonColor, "--min-height": "auto", padding: "0px 10px", flex: 'none'}}>
          <IonIcon icon={colorWand} slot="start" /> 
          {_dict.reworkText[lang]}
      </IonButton>*/}
      </div>

      { activateAI  && remainingRequests !== null && <span style={{fontWeight:"bold", color: remainingRequests > 0 ? "#008000" : "#ff6347", fontSize: "16px"}}>{_dict.remainingRequests[lang]}{remainingRequests}</span> }
    
      
      </>
    }
    {
      
    }
    
    
    <div style={{fontSize:"12px"}}>
    { activateAI && remainingRequests !== null && remainingRequests <= 0 && isSubscribed === false && <>({_dict.premiumUsersHave10NewDailyRequestsWhileBaseUsers5InTotal[lang]})
    <div>
    <IonButton style={{ color: '#FFFFFF', "--background": '#007ea7', fontSize: '0.8em' }} onClick={() => {logMe("click_premium",{from:"bulkImport"}); goToPayment(userUniqueId)}}>
        {_dict.freeQuotaPremiumBtnText[lang]}
    </IonButton>
    </div>
    </>}
    </div>
    
    </div>
    
    
    <IonModal isOpen={showModal} onDidDismiss={() => setShowModal(false)}>
        <IonList>
          {files.map(file => (
            <IonItem
              key={Object.keys(file)[0]}
              button
              onClick={() => handleFileClick(Object.keys(file)[0])}
            >
              {Object.values(file)[0]}
            </IonItem>
          ))}
        </IonList>

        <IonButton expand="block" onClick={() => setShowModal(false)}
        color="danger" style={{height:"60px", fontSize:"20px", width:"100%"}}>
          {_dict.syncBack[lang]}
        </IonButton>

    </IonModal>
    
    
    { isLoading && <div><IonSpinner  name="crescent" /></div> }
    <IonTextarea
          className="bulkImportTextarea"
          ref={textareaRef}
          placeholder={
            importMode === "story" ?
            _dict.storyMode[lang] :
            importMode === "flat" ?
            _dict.writeHereYourListOneWordPerLine[lang] :
            _dict.writeHereYourDialogue[lang]
          }
          onInput={() => setText(textareaRef.current?.value || '')}

          style={{
            border: '1px solid #ccc',
            borderRadius: '5px',
            display: isLoading ? "none" : "block",
            margin: '2px',
            fontSize: '18px',
            fontFamily: 'monospace',
            height: '45vh',
          }}
        />
      
      {showOnceSentenceAtATimeCheckboxJSX}
      {ignoreNewLinesCheckBoxJSX}
      <IonButton disabled={textareaRef.current?.value === undefined || textareaRef.current?.value?.length === 0 } size="large" onClick={() => setIsAddOrReplaceDialogOpen(true)} color="light">
        <IonIcon icon={arrowUpCircle} slot="start" /> {_dict.loadSentences[lang]}
        
      </IonButton>
      <AddOrReplaceDialog
      onClose={() => setIsAddOrReplaceDialogOpen(false)}
      onConfirm={(mergeMode:"add" | "replace") => handleSubmit(mergeMode)}
      
      />
    </>
  );
};

export default BulkImport;